<template>
  <form-layout :label="label">
    <read-only-textarea :value="value" />
  </form-layout>
</template>

<script>
import FormLayout from '@/views/templates/FormLayout'
import ReadOnlyTextarea from "@/views/atoms/inputs/ReadOnlyTextarea";

export default {
  name: "TextareaBrowseItem",
  components: {
    FormLayout,
    ReadOnlyTextarea,
  },
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: [String, null],
      required: true
    }
  },
}
</script>
